
import { defineComponent } from 'vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';

export default defineComponent({
  name: 'ExampleCheckDialog',

  components: { CustomButton, CustomDialog }
});
